import axios from '@/api/config/interceptor'
import { host } from '@/api/config/host'
import { _paramsToQueryString } from '@/utils/utils'

//登录
export const login = (params) => {
    return new Promise((resolve, reject) => {
        axios.post(`${host}/api/Auth/Token?${_paramsToQueryString(params)}`).then(res => {
            if (res.code == 0) {
                resolve(res.data)
            } else {
                reject(res)
            }
        })
    })
}
// 验证码登录
export const codeLogin = (params) => {
    return new Promise((resolve, reject) => {
        axios.post(`${host}/api/Auth/LoginByCode?${_paramsToQueryString(params)}`).then(res => {
            if (res.code == 0) {
                resolve(res.data)
            } else {
                reject(res)
            }
        })
    })
}